// Location: assets/bal-logo-marquee.js
// What: Sizes a seamless logo loop and manages its pause control.
// Why: Keeps editable brand links moving without per-frame JavaScript.
// RELEVANT FILES: sections/bal-logo-marquee.liquid, assets/bal-logo-marquee.css
if (!customElements.get('bal-logo-marquee')) {
  class BalLogoMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.group = this.querySelector('[data-group]');
      this.viewport = this.querySelector('[data-viewport]');
      this.button = this.querySelector('button');
      if (!this.group || !this.button) return;
      this.toggle = () => {
        const paused = this.toggleAttribute('data-paused');
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.setAttribute('aria-label', paused ? this.dataset.play : this.dataset.pause);
        this.button.textContent = paused ? '▶' : 'Ⅱ';
      };
      this.button.addEventListener('click', this.toggle);
      this.resize = new ResizeObserver(() => this.build());
      this.resize.observe(this.viewport);
      this.resize.observe(this.group);
      this.visibility = new IntersectionObserver(([entry]) => {
        this.toggleAttribute('data-offscreen', !entry.isIntersecting);
      });
      this.visibility.observe(this);
      this.build();
    }

    build() {
      const width = this.group.getBoundingClientRect().width;
      if (!width) return;
      this.track.querySelectorAll('[data-copy]').forEach((copy) => copy.remove());
      const animated = this.group.children.length > 1 && !window.Shopify?.designMode;
      if (animated) {
        const copies = Math.ceil(this.viewport.clientWidth / width);
        for (let index = 0; index < copies; index += 1) {
          const copy = this.group.cloneNode(true);
          copy.removeAttribute('data-group');
          copy.setAttribute('data-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach((item) => item.removeAttribute('data-shopify-editor-block'));
          copy.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
          this.track.append(copy);
        }
      }
      this.style.setProperty('--travel', `${-width}px`);
      this.style.setProperty('--duration', `${width / Number(this.dataset.speed || 35)}s`);
      this.toggleAttribute('data-ready', animated);
      this.button.hidden = !animated;
    }

    disconnectedCallback() {
      this.resize?.disconnect();
      this.visibility?.disconnect();
      this.button?.removeEventListener('click', this.toggle);
    }
  }
  customElements.define('bal-logo-marquee', BalLogoMarquee);
}
